
import { Component, Vue, Prop, } from 'vue-property-decorator'

@Component
export default class TableEmptyState extends Vue {
  @Prop({ required: true, }) readonly title!: string
  @Prop({ required: true, }) readonly image!: string
  @Prop({ required: false, default: false, }) readonly text!: string
}
